import type { UserRole } from "@/api/auth";

const ROLE_LABEL: Record<UserRole, string> = {
  owner: "Dueño",
  manager: "Jefe de ventas",
  salesperson: "Vendedor",
  technician: "Técnico",
  admin_staff: "Administración",
  datero: "Relevador",
};

export function roleLabel(role: UserRole): string {
  return ROLE_LABEL[role];
}
